export default "__VITE_ASSET__CMAv1ovd__"